export * from './msw-training.route';
export { training as Mytraining } from './msw-training.route';

export * from './msw-training.store';
export { default as TrainingStoreModule } from './msw-training.store';
